export default {
    kh: 'ພາສາຂະແມ',
    en: 'ພາ​ສາ​ອັງ​ກິດ',
    lao:"ພາສາລາວ",
    thai:"ພາສາໄທ"
};
